import PropTypes from 'prop-types';
import { ReactComponent as IconLike } from "features/likes/components/ButtonLike/assets/images/like.svg";
import styles from "features/likes/components/ButtonLike/ButtonLike.module.scss";
import Button from "components/ui/Button/Button";
import useLikes from "features/likes/hooks/useLikes";

const ButtonLike = ({ entityId, entityType, onReceivedCount }) => {
  const { isLoading, removeLike, addLike, isLiked } = useLikes(entityId, entityType, onReceivedCount);

  let classes = [ styles.button ];
  if (isLiked) {
    classes.push(styles[`button--liked`]);
  }

  if (isLoading) {
    classes.push(styles[`button--loading`]);
  }

  return (
    <Button variant={ `like` }
            onClick={ () => isLiked ? removeLike() : addLike() }
            className={ classes.join(` `) }
    >
      <IconLike/>
      <span>{ `Vind ik leuk!` }</span>
    </Button>
  )
}

ButtonLike.propTypes = {
  entityId: PropTypes.number.isRequired,
  entityType: PropTypes.string.isRequired,
  onReceivedCount: PropTypes.func.isRequired,
}

export default ButtonLike;
